import { createI18n } from 'vue-i18n';
import ru from './ru.json';

const messages = {
	en: {},
	ru: {},
	fi: {}
};

const i18n = createI18n({
	locale: 'ru',
	messages: messages
});

export default i18n;
